/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

$(document).ready(function () {
  console.log("The DOM is fully loaded and ready!");
  // Attach a click event listener to the body element
  document.body.addEventListener("click", function (e) {
    if (
      e.target.matches(
        ".cart__quantity .cart__quantity-minus.custom-minus-btn .icon-minus, .cart__quantity .cart__quantity-plus.custom-plus-btn .icon-plus"
      )
    ) {
      setTimeout(function () {
        if (document.body.classList.contains("template-cart")) {
          var mainWidthCart = document.querySelector(
            ".cart .cart__items .cart__item__image a"
          )?.offsetWidth;
          console.log("mainWidthCart:-" + mainWidthCart);

          if (mainWidthCart) {
            var itemContent = document.querySelector(
              ".cart .custom-pro-qty-price + .cart__items .cart__item__content"
            );
            if (itemContent) {
              itemContent.style.width = "calc(100% - " + mainWidthCart + "px)";
            }
          }
        }
      }, 1500);
    }
  });

  if ($("body").hasClass("template-cart")) {
    var mainWidthCart = $(".cart .cart__items .cart__item__image a").width();
    console.log("mainWidthCart:-" + mainWidthCart);
    if (mainWidthCart) {
      $(".cart .custom-pro-qty-price + .cart__items .cart__item__content").css(
        "width",
        "calc(100% - " + mainWidthCart + "px)"
      );
    }
  }
  $("body").on("click", ".custom-btn-sliderow", function () {
    $(this).toggleClass("active-cls");
    $(this)
      .parents(".sliderule__wrapper")
      .find(".d1-product-menu-main-mobile.custom-dropdown")
      .slideToggle();
  });
  var currentPath = window.location.pathname;
  $(".static-menu-list a").each(function () {
    var href = $(this).attr("href");
    if (href === currentPath) {
      $(this).closest("li").addClass("inline-nav--active");
    }
  });
  if ($(".materials.tab-section .review-grid-slider").length > 0) {
    var verticalSlider = false;
    // Fixed the selector by removing the extra dot before the selector
    if (
      $(".materials.tab-section .review-grid-slider.icon-vertical-desk")
        .length > 0
    ) {
      verticalSlider = true;
    }

    $(".materials.tab-section .review-grid-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      arrows: true,
      vertical: verticalSlider,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
    $(".materials.tab-section .review-grid-slider").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
  if ($(".review-grid-slider-mobile").length > 0) {
    var verticalSlider = false;
    // Fixed the selector by removing the extra dot before the selector
    if ($(".review-grid-slider-mobile.icon-vertical-mob").length > 0) {
      verticalSlider = true;
    }
    if ($(".review-grid-slider-mobile").hasClass("slick-initialized")) {
      $(".review-grid-slider-mobile").slick("unslick");
    }
    $(".review-grid-slider-mobile").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      arrows: true,
      vertical: verticalSlider,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
    $(".review-grid-slider-mobile").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
  if ($(".review-grid-slider").length > 0) {
    var verticalSlider = false;
    // Fixed the selector by removing the extra dot before the selector
    if ($(".review-grid-slider.icon-vertical-desk").length > 0) {
      verticalSlider = true;
    }
    $(".review-grid-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      arrows: true,
      vertical: verticalSlider,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
    $(".review-grid-slider").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }

  if ($(".cusom-review-grid-slider").length > 0) {
    var sliderSpeed = $(".cusom-review-grid-slider").attr("slider-speed-data");
    //   alert("sliderSpeed:-" + sliderSpeed);
    if ($(window).width() <= 748) {
      var verticalSlider = false;
      // Fixed the selector by removing the extra dot before the selector
      if ($(".cusom-review-grid-slider.icon-vertical-mob").length > 0) {
        verticalSlider = true;
      }
      if ($(".cusom-review-grid-slider").hasClass("slick-initialized")) {
        $(".cusom-review-grid-slider").slick("unslick");
      }
      $(".cusom-review-grid-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: sliderSpeed,
        dots: true,
        arrows: true,
        vertical: verticalSlider,
        prevArrow:
          '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
        nextArrow:
          '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
      });
    } else {
      var verticalSlider = false;
      // Fixed the selector by removing the extra dot before the selector
      if ($(".cusom-review-grid-slider.icon-vertical-desk").length > 0) {
        verticalSlider = true;
      }
      if ($(".cusom-review-grid-slider").hasClass("slick-initialized")) {
        $(".cusom-review-grid-slider").slick("unslick");
      }
      $(".cusom-review-grid-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: sliderSpeed,
        dots: true,
        arrows: true,
        vertical: verticalSlider,
        prevArrow:
          '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
        nextArrow:
          '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
      });
    }
    $(".cusom-review-grid-slider").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
  if ($(".image-with-custom-text-slider").length > 0) {
    var sliderSpeed = $(".image-with-custom-text-slider").attr(
      "auto-play-slider"
    );
    if ($(window).width() <= 749) {
      var verticalSlider = false;
      // Fixed the selector by removing the extra dot before the selector
      if ($(".image-with-custom-text-slider.icon-vertical-mob").length > 0) {
        verticalSlider = true;
      }
      if ($(".image-with-custom-text-slider").hasClass("slick-initialized")) {
        $(".image-with-custom-text-slider").slick("unslick");
      }
      $(".image-with-custom-text-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: sliderSpeed,
        dots: true,
        arrows: true,
        vertical: verticalSlider,
        prevArrow:
          '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
        nextArrow:
          '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
      });
    } else {
      var verticalSlider = false;
      // Fixed the selector by removing the extra dot before the selector
      if ($(".image-with-custom-text-slider.icon-vertical-desk").length > 0) {
        verticalSlider = true;
      }
      if ($(".image-with-custom-text-slider").hasClass("slick-initialized")) {
        $(".image-with-custom-text-slider").slick("unslick");
      }
      $(".image-with-custom-text-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        arrows: true,
        vertical: verticalSlider,
        prevArrow:
          '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
        nextArrow:
          '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
      });
    }
    $(".image-with-custom-text-slider").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
  if ($(".text-sliding-slider-enable").length > 0) {
    // var sliderSpeed = $(".custom-look-slider").attr("slider-speed-data");
    if ($(".text-sliding-slider-enable").hasClass("slick-initialized")) {
      $(".text-sliding-slider-enable").slick("unslick");
    }
    $(".text-sliding-slider-enable").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      fade: true,
      cssEase: "ease-in-out",
      speed: 400,
      arrows: false,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });

    $(".text-sliding-slider-enable").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
});

$(document).ready(function () {
  $(".custom-hide-on-loading").show();
  $(".d1-product-menu-main").attr("style", "display: flex;");
  $("body").on("click", ".custom-d1-product-nav", function () {
    console.log("enter mouse");
    $(".d1-product-menu-main").addClass("d1-open-menu");
    $("body").addClass("d1-open-menu-overlay");
  });

  $("body").on(
    "click",
    ".d1-pro-menu-close-icon,.d1-product-overlay",
    function () {
      console.log("enter mouse");
      $(".d1-product-menu-main").removeClass("d1-open-menu");
      $("body").removeClass("d1-open-menu-overlay");
    }
  );
  $("body").on("click", ".d1-product-overlay", function () {
    $(".d1-product-menu-main").removeClass("d1-open-menu");
    $("body").removeClass("d1-open-menu-overlay");
  });
  // hotspot state name map
  $("body").on("mouseenter", ".hot-spot-block", function () {
    console.log("mouse leave");
    $(this).find(".hot-spot-state-name").addClass("open-state");
  });
  $("body").on("mouseleave", ".hot-spot-block", function () {
    // console.log("mouse leave");
    $(this).find(".hot-spot-state-name").removeClass("open-state");
  });

  if ($(".pdp-desk .product-custom-slider-enabled").length > 0) {
    var sliderSpeed = $(".pdp-desk .product-custom-slider-enabled").attr(
      "slider-speed-data"
    );
    if (
      $(".pdp-desk .product-custom-slider-enabled").hasClass(
        "slick-initialized"
      )
    ) {
      $(".pdp-desk .product-custom-slider-enabled").slick("unslick");
    }
    $(".pdp-desk .product-custom-slider-enabled").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: sliderSpeed,
      dots: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
  }
  $(".product-custom-slider-enabled").hover(function () {
    $(this).find(".slick-arrow").toggleClass("show-arrows");
  });

  if ($(".custom-look-slider").length > 0) {
    // var sliderSpeed = $(".custom-look-slider").attr("slider-speed-data");
    if ($(".custom-look-slider").hasClass("slick-initialized")) {
      $(".custom-look-slider").slick("unslick");
    }
    $(".custom-look-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
    $(".custom-look-slider").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
  // custom hotspot mobile view
  $("body").on(
    "click",
    ".product-quick-add__close-outer button.product-quick-add__close.drawer__close",
    function () {
      $("body").removeClass("custom-hostpot-mobile-popup");
    }
  );
  $("body").on(
    "click",
    ".look__actions.mobile .btn,.custom-hotspot-btn",
    function () {
      $("body").addClass("custom-hostpot-mobile-popup");
      if ($(window).width() <= 748) {
        var newHeight = $(".look__image-container").height();
        $(".custom-hotspot-sct.look .look__aside.is-open .look__content").css(
          "height",
          "calc(100% - " + newHeight + "px)"
        );
      }
    }
  );
  $("body").on("hover", ".navlink.navlink--toplevel", function () {
    setTimeout(function () {
      $(this).eq(0).parents(".header__wrapper").removeClass("meganav--visible");
    }, 2000);
  });
  $("body").on("click", ".look__close.mobile", function () {
    $("body").removeClass("custom-hostpot-mobile-popup");
  });
  $("body").on("click", ".custom-hotspot-btn", function () {
    var sliderIndex = $(this).attr("data-slider-thumb");
    $(".custom-look-slider").slick("slickGoTo", sliderIndex);
  });
});

$(document).ready(function () {
  $("body").on("click", ".product-modal__close", function () {
    $(this).parents(".main_popup-size-guide").removeClass("open-new-popup");
    $(this).parents("body").removeClass("popup-body");
  });
  $("body").on("click", ".radio__legend__link.text-link", function () {
    $(this)
      .parents(".product__block")
      .find(".main_popup-size-guide")
      .addClass("open-new-popup");
    $(this).parents("body").addClass("popup-body");
  });
  $("body").on(
    "click",
    ".radio__buttons .custom-variants-option-btn",
    function () {
      const quickViewBtn = $(this)
        .parents(".product__selectors")
        .find(".custom-quick-view-btn");

      if (quickViewBtn.length) {
        quickViewBtn.css({
          display: "block",
          visibility: "hidden",
          position: "absolute",
        });
        setTimeout(function () {
          quickViewBtn.get(0).click();
        }, 200);
        setTimeout(function () {
          $(".custom-popup-close").click();
        }, 300);
      }
    }
  );
  $("body").on("click", ".custom-quick-view-btn", function () {
    // alert("00");
    // window.location.href = "/cart";
  });
  $(".custom-add-to-cart").click(function () {
    $(".custom-variant-section-option").fadeIn(500);
  });
  $(".custom-popup-close").click(function () {
    $(".custom-variant-section-option").fadeOut(500);
  });
  $("body").on("click", ".custom-popup-close", function () {
    $(this)
      .parents(".custom-variant-section-option")
      .removeClass("open-variant-popup");
    $(this).parents("body").removeClass("variant-popup-body");
  });
  $("body").on("click", ".custom-add-to-cart", function () {
    $(this)
      .parents(".product__block")
      .find(".custom-variant-section-option")
      .addClass("open-new-popup");
    $(this).parents("body").addClass("variant-popup-body");
  });
});
// Pdp Chart Guide started  //

$(document).ready(function () {
  // Function to convert inches to centimeters
  function toCentimeters(value) {
    return (value * 2.54).toFixed(2);
  }

  // Function to convert centimeters to inches
  function toInches(value) {
    return (value / 2.54).toFixed(2);
  }

  // Track the current unit (true for centimeters, false for inches)
  let isConvertedToCentimeters = false;

  // Handle Centimeters button click
  $(".cmButton").click(function () {
    if (isConvertedToCentimeters) {
      // If already in centimeters, switch to inches
      convertToInches();
      isConvertedToCentimeters = false;
      $(".progress-bar-item.cmButton").removeClass("active");
      $(".progress-bar-item.inchButton").addClass("active");
    } else {
      // Convert to centimeters
      convertToCentimeters();
      isConvertedToCentimeters = true;
      $(".progress-bar-item.cmButton").addClass("active");
      $(".progress-bar-item.inchButton").removeClass("active");
    }
  });

  // Handle Inches button click
  $(".inchButton").click(function () {
    if (!isConvertedToCentimeters) {
      // If already in inches, switch to centimeters
      convertToCentimeters();
      isConvertedToCentimeters = true;
      $(".progress-bar-item.inchButton").removeClass("active");
      $(".progress-bar-item.cmButton").addClass("active");
    } else {
      // Convert to inches
      convertToInches();
      isConvertedToCentimeters = false;
      $(".progress-bar-item.inchButton").addClass("active");
      $(".progress-bar-item.cmButton").removeClass("active");
    }
  });

  // Function to convert table values to centimeters
  function convertToCentimeters() {
    $(
      "#sizeTable .chest, #sizeTable .bodyLength, #sizeTable .sleeveLength, #sizeTable .waistLength, #sizeTable .inseamLength, #sizeTable .ShoulderGuide"
    ).each(function () {
      if (isNaN($(this).text())) return;
      var inchValue = parseFloat($(this).text());
      var cmValue = toCentimeters(inchValue);
      $(this).text(cmValue);
      $(this).data("unit", "centimeters");
    });
  }

  // Function to convert table values to inches
  function convertToInches() {
    $(
      "#sizeTable .chest, #sizeTable .bodyLength, #sizeTable .sleeveLength, #sizeTable .waistLength, #sizeTable .inseamLength, #sizeTable .ShoulderGuide"
    ).each(function () {
      if (isNaN($(this).text())) return;
      var cmValue = parseFloat($(this).text());
      var inchValue = toInches(cmValue);
      $(this).text(inchValue);
      $(this).data("unit", "inches");
    });
  }

  // Function to convert table values to inches
  function convertToInches() {
    $(
      "#sizeTable .chest, #sizeTable .bodyLength, #sizeTable .sleeveLength, #sizeTable .waistLength, #sizeTable .inseamLength, #sizeTable .ShoulderGuide"
    ).each(function () {
      if (isNaN($(this).text())) return;
      var cmValue = parseFloat($(this).text());
      var inchValue = toInches(cmValue);
      $(this).text(inchValue);
      $(this).data("unit", "inches");
    });
  }
  //----- Blog Page Slider started-----  //
  if ($(".inline-nav-grid-wrapper").length > 0) {
    $(".inline-nav-grid-wrapper").addClass("inline-nav-animate");
  }
  // if (
  //    window.location.pathname.includes("/pages/trousers-shorts") ||
  //   window.location.pathname.includes("/pages/tops") ||
  //   window.location.pathname.includes("/pages/makers") ||
  //   window.location.pathname.includes("/pages/d1-mens-product") ||
  //   window.location.pathname.includes("/pages/d2-mens-product")
  // ) {
  //   $("body").addClass("has-first-section-overlay-header");
  // } else {
  //   if (window.location.pathname.includes("/pages")) {
  //     console.log("Pages");
  //     $("body .header__wrapper").removeAttr("data-header-transparent");
  //   }
  // }
 
  if ($(".cstm-blog-post-slider").length > 0) {
    if ($(".cstm-blog-post-slider").hasClass("slick-initialized")) {
      $(".cstm-blog-post-slider").slick("unslick");
    }
    var verticalSlider = false;
    if ($(".cstm-blog-post-slider.icon-vertical-desk").length > 0) {
      verticalSlider = true;
    }
    $(".cstm-blog-post-slider").slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      arrows: true,
      vertical: verticalSlider,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            vertical: verticalSlider,
          },
        },
      ],
    });
    $(".cstm-blog-post-slider").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }

  if ($(".cstm-article-page-slider").length > 0) {
    var sliderSpeed = $(".cstm-article-page-slider").attr(
      "article-slider-speed"
    );
    if ($(".cstm-article-page-slider").hasClass("slick-initialized")) {
      $(".cstm-article-page-slider").slick("unslick");
    }
    var verticalSlider = false;
    // Fixed the selector by removing the extra dot before the selector
    if ($(".cstm-article-page-slider.icon-vertical-desk").length > 0) {
      verticalSlider = true;
    }
    $(".cstm-article-page-slider").slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: sliderSpeed,
      dots: true,
      centerMode: false,
      arrows: true,
      vertical: verticalSlider,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            prevArrow:
              '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
            nextArrow:
              '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
          },
        },
      ],
    });
    $(".cstm-article-page-slider").hover(function () {
      console.log("shi h hover");
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
});
$(document).ready(function () {
  // Initialize Slick slider
  if ($(".pdp-mobile .product-custom-slider-enabled").length > 0) {
    var sliderSpeed = $(".pdp-mobile .product-custom-slider-enabled").attr(
      "slider-speed-data"
    );
    if (
      $(".pdp-mobile .product-custom-slider-enabled").hasClass(
        "slick-initialized"
      )
    ) {
      $(".pdp-mobile .product-custom-slider-enabled").slick("unslick");
    }
    $(".pdp-mobile .product-custom-slider-enabled").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
    $(".pdp-mobile .product-custom-slider-enabled").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
});

// hotspot scroll resize load section
$(document).bind("scroll resize load", function () {
  if ($(window).width() <= 748) {
    var newHeight = $(".look__image-container").height();
    $(".custom-hotspot-sct.look .look__aside.is-open .look__content").css(
      "height",
      "calc(100% - " + newHeight + "px)"
    );
  }
});

$(document).ready(function () {
  if ($(".no-parallax").length <= 0) {
    gsap.registerPlugin(ScrollTrigger);
    // function gsapCode(){
    let getRatio = (el) =>
      window.innerHeight / (window.innerHeight + el.offsetHeight);

    // Get all .index-hero elements
    const sections = $(".index-hero");

    // Check the number of sections
    if (sections.length === 2) {
      // If there are only 2 sections, apply a negative transform to the second one
      sections.each(function (i) {
        const section = $(this);
        const bg = section.find(".hero__images.frame__item img");

        gsap.fromTo(
          bg[0], // Use the first element in the jQuery object
          {
            // Initial transform state
            transform: () =>
              i
                ? `translateY(${
                    -window.innerHeight * getRatio(section[0]) + 40
                  }px) scale(1.02)` // Slightly more negative for the second section
                : `translateY(-5px) scale(1.02)`,
          },
          {
            // Final transform state
            transform: () =>
              `translateY(${
                window.innerHeight * (1 - getRatio(section[0]))
              }px) scale(1.08)`,
            ease: "none",
            scrollTrigger: {
              trigger: section[0],
              start: () => (i ? "top bottom" : "top top"),
              end: "bottom top",
              scrub: true,
              markers: true,
              invalidateOnRefresh: true,
              once: false,
              onEnter: () => {
                // Action when entering the section
                console.log(`Entering section ${i + 1}`);
              },
              onLeave: () => {
                // Action when leaving the section
                console.log(`Leaving section ${i + 1}`);
              },
              onEnterBack: () => {
                // Action when entering back into the section
                console.log(`Entering back into section ${i + 1}`);
              },
              onLeaveBack: () => {
                // Action when leaving back from the section
                console.log(`Leaving back from section ${i + 1}`);
              },
            },
          }
        );
      });
    } else {
      // If there are more than 2 sections, apply the original animation D1 page
      sections.each(function (i) {
        const section = $(this);
        const bg = section.find(".hero__images.frame__item img");

        gsap.fromTo(
          bg[0], // Use the first element in the jQuery object
          {
            // Initial transform state
            transform: () =>
              i
                ? `translateY(${
                    -window.innerHeight * getRatio(section[0])
                  }px) scale(1.02)`
                : `translateY(-5px) scale(1.02)`,
          },
          {
            // Final transform state
            transform: () =>
              `translateY(${
                window.innerHeight * (1 - getRatio(section[0]))
              }px) scale(1.08)`,
            ease: "none",
            scrollTrigger: {
              trigger: section[0],
              start: () => (i ? "top bottom" : "top top"),
              // start: "top bottom",
              end: "bottom top",
              scrub: true,
              markers: false,
              invalidateOnRefresh: true,
              once: false,
            },
          }
        );
      });

      // const isMobilee = window.innerWidth <= 768;
      // if (isMobilee) {
      //   const section1 = document.querySelector(".templatee-product");
      //   const pdp = section1.querySelector(".hero__images.frame__item img");

      //   if (pdp) {
      //     gsap.fromTo(
      //       pdp,
      //       {
      //         transform: `translateY(-300px) scale(1.02)`,
      //       },
      //       {
      //         transform: `translateY(${
      //           window.innerHeight * (1 - getRatio(section1))
      //         }px) scale(1.08)`,
      //         ease: "none",
      //         scrollTrigger: {
      //           trigger: section1,
      //           start: "top bottom",
      //           end: "bottom top",
      //           scrub: true,
      //           markers: false,
      //           invalidateOnRefresh: true,
      //           once: false,
      //         },
      //       }
      //     );
      //   }
      // }
    }

    //  Product page parallax
    const isMobilee = window.innerWidth <= 768;
    if (isMobilee) {
      const section1 = document.querySelector(".templatee-product");
      const pdp = section1.querySelector(".hero__images-pdp.frame__item img");

      if (pdp) {
        gsap.fromTo(
          pdp,
          {
            transform: `translateY(-300px) scale(1.02)`,
          },
          {
            transform: `translateY(${
              window.innerHeight * (1 - getRatio(section1))
            }px) scale(1.08)`,
            ease: "none",
            scrollTrigger: {
              trigger: section1,
              start: "top bottom",
              end: "bottom top",
              scrub: true,
              markers: false,
              invalidateOnRefresh: true,
              once: false,
            },
          }
        );
      }
    } else {
      $(".templatee-product").each(function (i) {
        const section3 = $(this);
        const bg = section3.find(".hero__images-pdp.frame__item img");

        gsap.fromTo(
          bg[0], // Use the first image in the jQuery object
          {
            // Initial transform state
            transform: () =>
              i
                ? `translateY(${
                    -window.innerHeight * getRatio(section3[0])
                  }px) scale(1.02)`
                : `translateY(-300px) scale(1.02)`,
          },
          {
            // Final transform state
            transform: () =>
              `translateY(${
                window.innerHeight * (1 - getRatio(section3[0]))
              }px) scale(1.08)`,
            ease: "none",
            scrollTrigger: {
              trigger: section3[0],
              // start: "top bottom",
              start: () => (i ? "top top" : "top bottom"),
              end: "bottom top",
              scrub: true,
              markers: false,
              invalidateOnRefresh: true,
              once: false,
            },
          }
        );
      });
    }
    window.addEventListener("load", () => {
      ScrollTrigger.refresh();
    });
  }
});

// Impact page slider
$(document).ready(function () {
  if ($(".meterials-tab-block-slider-enabled").length > 0) {
    if (
      $(".meterials-tab-block-slider-enabled").hasClass("slick-initialized")
    ) {
      $(".meterials-tab-block-slider-enabled").slick("unslick");
    }
    $(".meterials-tab-block-slider-enabled").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
    $(".meterials-tab-block-slider-enabled").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
  if ($(".pdp-desk.impact-page-tab-slider-enable-desktop").length > 0) {
    var verticalSlider = false;
    var autoplay_status = $(".pdp-desk.impact-page-tab-slider-enable-desktop").attr("autplay-status");
    if(autoplay_status === "true"){
      autoplay_status= true;
    }else{
      autoplay_status= false;
    }
    var autoplay_speed = $(".pdp-desk.impact-page-tab-slider-enable-desktop").attr("autoplay-speed");
    console.log("autoplay_status desktop",autoplay_status);
    console.log("autoplay_speed desktop",autoplay_speed);
    
    if (
      $(".pdp-desk.impact-page-tab-slider-enable-desktop.icon-vertical-mob")
        .length > 0
    ) {
      verticalSlider = true;
    }
    if (
      $(".pdp-desk.impact-page-tab-slider-enable-desktop").hasClass(
        "slick-initialized"
      )
    ) {
      $(".pdp-desk.impact-page-tab-slider-enable-desktop").slick("unslick");
    }
    $(".pdp-desk.impact-page-tab-slider-enable-desktop").slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: autoplay_status,
      autoplaySpeed: autoplay_speed,
      dots: true,
      arrows: true,
      vertical: verticalSlider,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
    $(".pdp-desk.impact-page-tab-slider-enable-desktop").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
  if ($(".pdp-mobile.impact-page-tab-slider-enable-mobile").length > 0) {
    var verticalSlider = false;
    var autoplay_status = $(".pdp-mobile.impact-page-tab-slider-enable-mobile").attr("autplay-status");
    var autoplay_speed = $(".pdp-mobile.impact-page-tab-slider-enable-mobile").attr("autoplay-speed");
    if(autoplay_status === "true"){
      autoplay_status= true;
    }else{
      autoplay_status= false;
    }
    console.log("autoplay_status mobile",autoplay_status);
    console.log("autoplay_speed mobile",autoplay_speed);
    if (
      $(".pdp-mobile.impact-page-tab-slider-enable-mobile.icon-vertical-mob")
        .length > 0
    ) {
      verticalSlider = true;
    }
    if (
      $(".pdp-mobile.impact-page-tab-slider-enable-mobile").hasClass(
        "slick-initialized"
      )
    ) {
      $(".pdp-mobile.impact-page-tab-slider-enable-mobile").slick("unslick");
    }
    $(".pdp-mobile.impact-page-tab-slider-enable-mobile").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: autoplay_status,
      autoplaySpeed: autoplay_speed,
      dots: true,
      arrows: true,
      vertical: verticalSlider,
      prevArrow:
        '<button type="button" class="slider__button slider__button--prev slick-prev slick-arrow" data-button-arrow="" data-button-prev="">Previous</button>',
      nextArrow:
        '<button type="button" class="slider__button slider__button--next slick-next slick-arrow" data-button-arrow="" data-button-next="">Next</button>',
    });
    $(".pdp-mobile.impact-page-tab-slider-enable-mobile").hover(function () {
      $(this).find(".slick-arrow").toggleClass("show-arrows");
    });
  }
});

$(document).ready(function () {
  if (window.innerWidth <= 768) {
    const swiperInstances = [];

    $(".impact-page .swiper-container").each(function () {
      const $container = $(this);
      const $slides = $container.find(".swiper-slide");
      let activeIndex = 0;

      $slides.each(function (index) {
        if ($(this).hasClass("tab_active")) {
          activeIndex = index;
        }
      });

      const swiper = new Swiper(this, {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: true,
        loopedSlides: $slides.length,
        centeredSlides: true,
        initialSlide: activeIndex,
        freeMode: false,
        scrollbar: {
          el: $container.find(".swiper-scrollbar")[0],
          draggable: true,
          hide: false,
        },
      });

      // Save instance and its initial index
      swiperInstances.push({
        swiper,
        initialIndex: activeIndex,
      });
    });

    // Global click listener to reset all sliders
    $(document).on("click", function () {
      swiperInstances.forEach(({ swiper, initialIndex }) => {
        swiper.slideToLoop(initialIndex, 500); // 500ms animation
      });
    });
  }
});
// The details section slider start
function initMobileSlider() {
  if (window.innerWidth < 750) {
    if (!$(".pdp-video-image-grid_wrp").hasClass("slick-initialized")) {
      $(".pdp-video-image-grid_wrp").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
      });
    }
  } else {
    // Destroy slick when going back to desktop
    if ($(".pdp-video-image-grid_wrp").hasClass("slick-initialized")) {
      $(".pdp-video-image-grid_wrp").slick("unslick");
    }
  }
}

// Run on page load
$(document).ready(function () {
  initMobileSlider();
});

// Run on resize (without refresh)
$(window).on("resize", function () {
  initMobileSlider();
});

// The details section slider End


if (window.innerWidth < 750) {
  setTimeout(function(){
    $(".related__products #product-recommendations").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      // autoplay: true,
      // autoplaySpeed: 3000,
    });
  },3500);
}


(function () {
})();
